import { useRef, useState } from "react";
import { ADDITIONAL_AMOUNT_STATUS } from "containers/pmaOnboarding/services/data.transformers";

import AdditionalAmountForm from "./forms";
import AdditionalAmountReceipt from "./receipt";

const PmaAdditionalAmount = ({
  boardLoading,
  additionalStatus,
  currentStageDetails,
  onbUuid,
  onFinishAdditionalAmount,
  onStageShow,
}) => {
  const amount = currentStageDetails?.page_info?.find(
    (el) => el.component_name === "additional_amount"
  )?.infos?.[0]?.value;

  const accounts = currentStageDetails?.page_info?.find(
    (el) => el.component_name === "accounts"
  )?.infos;

  const formRef = useRef();

  const render = () => {
    switch (additionalStatus) {
      case ADDITIONAL_AMOUNT_STATUS.FORM:
        return (
          <AdditionalAmountForm
            amount={amount}
            accounts={accounts}
            formRef={formRef}
            loading={boardLoading}
            onbUuid={onbUuid}
            onFinish={onFinishAdditionalAmount}
          />
        );

      case ADDITIONAL_AMOUNT_STATUS.RECEIPT:
      default:
        return (
          <AdditionalAmountReceipt amount={amount} onStageShow={onStageShow} />
        );
    }
  };

  return <div className="pt-20">{render()}</div>;
};
export default PmaAdditionalAmount;
